const PRODUCTION_PAGES_HOST = "dbvdw-dagrapport-pwa.pages.dev";

export function canonicalProductionHref(
  currentHref: string,
  environment: string,
): string | null {
  if (environment !== "production") return null;

  let current: URL;
  try {
    current = new URL(currentHref);
  } catch {
    return null;
  }

  const hostname = current.hostname.toLowerCase();
  if (hostname === PRODUCTION_PAGES_HOST) return null;
  if (!hostname.endsWith(`.${PRODUCTION_PAGES_HOST}`)) return null;

  current.protocol = "https:";
  current.hostname = PRODUCTION_PAGES_HOST;
  current.port = "";
  return current.href;
}
